// extracted by extract-css-chunks-webpack-plugin
module.exports = {"group_outcome":"GroupOutcome__group_outcome--3r7JA","badge":"GroupOutcome__badge--1IPAK"};